import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "opstrai.session_token";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 45000,
});

export function setStoredToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function getStoredToken() {
  return localStorage.getItem(TOKEN_KEY);
}

api.interceptors.request.use((config) => {
  const t = getStoredToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// Sprint 2H P3 — global responsibility-acceptance interceptor. On 403
// responsibility_acceptance_required, ResponsibilityModal registers a callback
// via setResponsibilityInterceptor. We invoke it with the scheme_id parsed
// from the request URL + a retry closure that replays the original request.
let _responsibilityCb = null;
export const setResponsibilityInterceptor = (fn) => { _responsibilityCb = fn; };

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const detail = err?.response?.data?.detail;
    const isResp403 =
      err?.response?.status === 403 &&
      (detail?.error === "responsibility_acceptance_required" ||
        (typeof detail === "string" && detail.includes("responsibility")));
    if (isResp403 && _responsibilityCb) {
      const url = err.config?.url || "";
      const m = url.match(/schemes\/([^\/]+)/);
      const scheme_id = m ? m[1] : null;
      return new Promise((resolve, reject) => {
        _responsibilityCb({
          scheme_id,
          retryOriginal: () => api.request(err.config).then(resolve).catch(reject),
        });
      });
    }
    return Promise.reject(err);
  }
);

export const apiError = (e) => {
  // Sprint 1 Week 2 hardening: NEVER return non-string. FastAPI 422 returns
  // detail as a list of {loc, msg, type} dicts — surface the first .msg as a
  // friendly fallback. Returning an object would crash any React toast/JSX.
  const detail = e?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    if (typeof first === "string") return first;
    if (first && typeof first === "object" && typeof first.msg === "string") return first.msg;
  }
  if (detail && typeof detail === "object" && typeof detail.message === "string") return detail.message;
  if (typeof e?.response?.data === "string") return e.response.data;
  if (typeof e?.message === "string") return e.message;
  return "Something went wrong.";
};
